// Function to reorder list items dynamically
function reorderListItems(listSelector, videoClass, firstVideoOrder, secondVideoOrder) {
  const listItems = document.querySelectorAll(`${listSelector} li`);
  let videoItems = [];
  let nonVideoItems = [];

  // Separate video and non-video items
  listItems.forEach((item) => {
    if (item.classList.contains(videoClass)) {
      videoItems.push(item);
    } else {
      nonVideoItems.push(item);
    }
  });

  // Apply order for non-video items
  nonVideoItems.forEach((item, index) => {
    item.style.order = index + 1; // Start non-video items' order from 1
  });

  // Apply order for video items based on their position
  videoItems.forEach((item, index) => {
    if (index === 0) {
      item.style.order = firstVideoOrder; // First video at position 3
    } else if (index === 1) {
      item.style.order = secondVideoOrder; // Second video at position 5
    } else {
      item.style.order = secondVideoOrder + (index - 1) + 1; // Remaining videos after position 5
    }
  });

  // Adjust remaining non-video items after video items
  nonVideoItems.forEach((item) => {
    let itemOrder = parseInt(item.style.order);
    if (itemOrder >= firstVideoOrder) {
      item.style.order = itemOrder + videoItems.length;
    }
  });
}

// Create a MutationObserver to watch for changes in the target lists
const observer = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === "childList") {
      console.log("DOM changed. Running reorder function...");

      // Reorder for both desktop and mobile lists
      reorderListItems(".thumbnail-list", "product-media-video", 3, 5);
      reorderListItems(".mobile_thumbnail-list", "product-media-video", 3, 5);
    }
  });
});

// Target nodes and configuration for observing
const desktopList = document.querySelector("ul.thumbnail-list");
const mobileList = document.querySelector("ul.mobile_thumbnail-list");
const config = { childList: true, subtree: true };

// Run reorder function initially and start observing changes
if (desktopList || mobileList) {
  console.log("Running reorder function initially...");

  // Initial run for both desktop and mobile lists
  if (desktopList) reorderListItems(".thumbnail-list", "product-media-video", 3, 5);
  if (mobileList) reorderListItems(".mobile_thumbnail-list", "product-media-video", 3, 5);

  // Start observing desktop and mobile lists
  if (desktopList) observer.observe(desktopList, config);
  if (mobileList) observer.observe(mobileList, config);

  console.log("MutationObserver is now observing DOM changes.");
} else {
  console.error("Target nodes not found: ul.thumbnail-list or ul.mobile_thumbnail-list");
}
